const HAVEN_LOGIN_TOKEN_KEY = "haven__login_token__";

type TokenChangeListener = () => void;

const tokenChangeListeners: TokenChangeListener[] = [];

const notifyLoginTokenChanged = (): void => {
  tokenChangeListeners.forEach((listener) => {
    try {
      listener();
    } catch {

      /* ignore listener failures */
    }
  });
};

/**
 * Register for same-tab login / logout (and cross-tab via `storage`).
 * Used by GraphQL Phoenix socket.
 */
export const subscribeLoginTokenChanges = (fn: TokenChangeListener): (() => void) => {
  tokenChangeListeners.push(fn);
  return () => {
    const idx = tokenChangeListeners.indexOf(fn);
    if (idx !== -1) {
      tokenChangeListeners.splice(idx, 1);
    }
  };
};

if (typeof window !== "undefined") {
  window.addEventListener("storage", (event: StorageEvent) => {
    if (event.key === HAVEN_LOGIN_TOKEN_KEY) {
      notifyLoginTokenChanged();
    }
  });
}

export const userLoginToken = (): string | null =>
  localStorage.getItem(HAVEN_LOGIN_TOKEN_KEY);

export const loginWithHavenToken = (token: string): void => {
  localStorage.setItem(HAVEN_LOGIN_TOKEN_KEY, token);
  notifyLoginTokenChanged();
};

export const wipeToken = (): void => {
  localStorage.removeItem(HAVEN_LOGIN_TOKEN_KEY);
  localStorage.removeItem("Meteor.loginToken");
  localStorage.removeItem("meteorUserId");
  localStorage.removeItem("Meteor.loginTokenExpires");
  localStorage.removeItem("Meteor.userId");
  notifyLoginTokenChanged();
};

// export const userIsAuthenticated = (): boolean => userLoginToken() !== null;
